import React, { Dispatch, FC, SetStateAction } from "react";
import { CategoryData, Product, menuSchedule } from "data/data";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TabCategoriesFilter from "./TabCategoriesFilter";
import MenuScheduleFilter from "./MenuScheduleFilter";
import Cookies from "js-cookie";
import { useRestaurantStatus } from "../hooks/useRestaurantStatus";
import { ClockIcon, MapPinIcon } from "@heroicons/react/24/outline";

export interface HeaderFilterSectionProps {
  className?: string;
  setItemData?: Dispatch<SetStateAction<Product[]>>;
  itemData?: Product[];
  renderAllData?: () => void;
  categoryData?: CategoryData[];
  menuScheduleData?: menuSchedule[];
  searchProduct?: string;
  getItemData?: any;
  setActivity?: any;
  imageUrl?: string;
  onlineOrderSettings: any;
  loading: boolean;
  activeCategoryId?: number | null;
  onCategoryClick?: (categoryId: number | null) => void;
}

const HeaderFilterSection: FC<HeaderFilterSectionProps> = ({
  className = "",
  categoryData,
  menuScheduleData,
  onlineOrderSettings,
  loading,
  activeCategoryId,
  onCategoryClick,
}) => {
  const navigate = useNavigate();
  const [selectedSchedule, setSelectedSchedule] = useState<menuSchedule[] | null>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [hasError, setHasError] = useState(false);

  const status = useRestaurantStatus({
    menuScheduleData: menuScheduleData || [],
    updateInterval: 60000,
  });

  const handlemenuSchedule = () => {
    if (menuScheduleData) {
      setSelectedSchedule(menuScheduleData);
      setModalOpen(true);
    }
  };

  useEffect(() => {
    const merchantname = Cookies.get("merchantname");
    if (hasError) {
      navigate(`/${merchantname}/Page404`);
    }
  }, [hasError]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-24">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500 dark:border-primary-400"></div>
      </div>
    );
  }

  const merchantAddress = Cookies.get("merchantAddress");

  return (
    <>
      {/* Compact restaurant info bar -- scrolls away */}
      <div className={`${className}`}>
        <div className="px-4 py-3 bg-white dark:bg-slate-900 border-b border-slate-100 dark:border-slate-800">
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <h1 className="text-base font-bold text-slate-900 dark:text-slate-100 truncate">
                {onlineOrderSettings?.titleText || "Menu"}
              </h1>
              {onlineOrderSettings?.customTextOne && (
                <p className="text-xs text-slate-500 dark:text-slate-400 truncate">
                  {onlineOrderSettings.customTextOne}
                </p>
              )}
              {merchantAddress && (
                <p className="text-xs text-slate-400 dark:text-slate-500 truncate flex items-center gap-1 mt-0.5">
                  <MapPinIcon className="w-3 h-3 flex-shrink-0" />
                  {merchantAddress}
                </p>
              )}
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <span
                className="px-2.5 py-1 rounded-full text-[11px] font-semibold text-white whitespace-nowrap"
                style={{ backgroundColor: status?.color || "#6B7280" }}
              >
                {status?.text}
              </span>
              <button
                className="flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-medium bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors whitespace-nowrap"
                onClick={handlemenuSchedule}
              >
                <ClockIcon className="w-3 h-3" />
                Hours
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Category tabs -- sticky */}
      <TabCategoriesFilter
        categoryData={categoryData}
        activeCategoryId={activeCategoryId}
        onCategoryClick={onCategoryClick}
      />

      {selectedSchedule && (
        <MenuScheduleFilter
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          menuschedule={selectedSchedule || []}
        />
      )}
    </>
  );
};

export default HeaderFilterSection;
